import {
  FETCH_FE_POD_REQUEST,
  FETCH_FE_POD_SUCCESS,
  FETCH_FE_POD_FAILURE,
} from '../types/fePod.types';

const initialState = {
  loading: null,
  data: [],
  error: '',
};

const fePodReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FE_POD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_FE_POD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: '',
      };
    case FETCH_FE_POD_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default fePodReducer;
